// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9bc84750","879":"4d238b94"}[chunkId] + ".chunk.js";
};